import type { AxfoodExternalVoucher } from '@occ/api-client';

export enum VoucherTypes {
  OMNI = 'omni',
  ONLINE = 'online',
  SELFCHECKOUT = 'selfcheckout',
  SELFSCAN = 'selfscan',
}

const getVoucherType = (voucher: AxfoodExternalVoucher) => {
  const { voucherChannelData } = voucher;
  return voucherChannelData?.omni
    ? VoucherTypes.OMNI
    : voucherChannelData?.online
      ? VoucherTypes.ONLINE
      : voucherChannelData?.selfcheckout
        ? VoucherTypes.SELFCHECKOUT
        : VoucherTypes.SELFSCAN;
};

export default getVoucherType;
